
export const cleanLocalStorage = (key: string) => {
    localStorage.removeItem(key);
};